import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { StaffCombobox } from "@/components/StaffCombobox";
import { Plus } from "lucide-react";
import { toast } from "sonner";

const BLANK = { client_name: "", matter_number: "", title: "", practice_group: "", assigned_to: "", assigned_to_email: "", stage: "" };

export function MatterCreateDialog({ groups, stages, onCreate }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(BLANK);
  const submit = async () => {
    if (!form.client_name) return toast.error("Client name is required");
    const ok = await onCreate({ ...form, stage: form.stage || stages[0]?.key });
    if (ok) { setOpen(false); setForm(BLANK); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) setForm(BLANK); }}>
      <DialogTrigger asChild><Button data-testid="add-matter-btn"><Plus className="h-4 w-4 mr-1.5" /> New Matter</Button></DialogTrigger>
      <DialogContent className="max-w-lg">
        <DialogHeader><DialogTitle>Open a New Matter</DialogTitle><DialogDescription className="sr-only">Create a matter.</DialogDescription></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-2"><Label className="text-xs">Client Name</Label><Input data-testid="matter-client" value={form.client_name} onChange={(e) => setForm({ ...form, client_name: e.target.value })} /></div>
          <div><Label className="text-xs">Matter Number</Label><Input data-testid="matter-number" value={form.matter_number} onChange={(e) => setForm({ ...form, matter_number: e.target.value })} placeholder="PI-2026-0001" /></div>
          <div><Label className="text-xs">Assigned To</Label><StaffCombobox testid="matter-assigned" value={form.assigned_to} onChange={(name, email) => setForm({ ...form, assigned_to: name, assigned_to_email: email })} /></div>
          <div className="col-span-2"><Label className="text-xs">Matter Title / Description</Label><Input data-testid="matter-title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} /></div>
          <div>
            <Label className="text-xs">Practice Group</Label>
            <Select value={form.practice_group} onValueChange={(v) => setForm({ ...form, practice_group: v })}>
              <SelectTrigger data-testid="matter-pg"><SelectValue placeholder="Select…" /></SelectTrigger>
              <SelectContent>{groups.map((g) => <SelectItem key={g.id} value={g.name}>{g.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs">Starting Stage</Label>
            <Select value={form.stage} onValueChange={(v) => setForm({ ...form, stage: v })}>
              <SelectTrigger data-testid="matter-stage"><SelectValue placeholder="Intake & Screening" /></SelectTrigger>
              <SelectContent>{stages.map((s) => <SelectItem key={s.key} value={s.key}>{s.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter><Button data-testid="save-matter-btn" onClick={submit}>Open Matter</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
